var exports = {
  "container": "xf0b3b88a--969a26--container",
  "text": "xf0b3b88a--969a26--text",
  "simplified-text": "xf0b3b88a--969a26--simplified-text",
  "work-time": "xf0b3b88a--969a26--work-time",
};

module.exports = exports;
